import script from "./UserInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./UserInfoModal.vue?vue&type=style&index=0&id=61ce6513&lang=css"
import "./UserInfoModal.vue?vue&type=style&index=1&id=61ce6513&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ce6513"]])

export default __exports__